import PropTypes from "prop-types";
import { ReactComponent as Print } from "../../assets/icons/print.svg";
import React from "react";
import { Button } from "@nextui-org/button";

const PrintButton = ({ onPrint }) => {
  return (
    <Button
      className="w-fit"
      startContent={<Print />}
      onPress={onPrint}
      isDisabled
    >
      พิมพ์
    </Button>
  );
};

PrintButton.propTypes = {
  onPrint: PropTypes.func,
};

export default PrintButton;
